import React from 'react';
import TicketAccessSection from 'flow/components/tickets/ticket-info-section/access/TicketAccessSection';
import TicketIdInfoItem from 'flow/components/tickets/ticket-info-section/TicketIdInfoItem';
import TicketOptionsSectionItem from 'flow/components/tickets/ticket-info-section/options-section/TicketOptionsSectionItem';
import TicketTagsList from 'flow/components/tickets/TicketTagsList';
import { TicketKey } from 'flow/types/EntityKeys';

interface Props {
    ticketKey: TicketKey;
}

const TicketDetailsTabContent = ({ ticketKey }: Props) => {
    return (
        <div className="flex flex-col gap-y-6 pb-3">
            <TicketOptionsSectionItem ticketKey={ticketKey} />
            <TicketIdInfoItem ticketKey={ticketKey} />
            <TicketAccessSection ticketKey={ticketKey} />
            <TicketTagsList ticketKey={ticketKey} />
        </div>
    );
};

export default React.memo(TicketDetailsTabContent);
